import React, { useEffect, useState } from 'react';
import { initAuth } from '../services/auth';

// Holds the app back until sign-in is settled, so no screen fires API calls
// without a token. In alb mode / local dev it renders the app immediately
// after one config request.
export default function AuthGate({ children }) {
  const [state, setState] = useState({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    initAuth()
      .then((result) => { if (!cancelled) setState(result); })
      .catch((err) => {
        console.error('Sign-in failed', err);
        if (!cancelled) setState({ status: 'error', message: String(err && err.message ? err.message : err) });
      });
    return () => { cancelled = true; };
  }, []);

  if (state.status === 'off' || state.status === 'signed-in') return children;

  if (state.status === 'error') {
    return (
      <div className="h-screen flex items-center justify-center bg-slate-50 font-body">
        <div className="max-w-md m-4 p-6 bg-white rounded-2xl border border-slate-200 shadow-sm space-y-3">
          <h1 className="text-sm font-black text-slate-800">Could not sign you in</h1>
          <p className="text-xs text-slate-500 break-words">{state.message}</p>
          <button
            onClick={() => window.location.assign('/')}
            className="px-4 py-2 rounded-xl bg-slate-800 text-white text-xs font-bold hover:bg-slate-700"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  // 'loading' or 'redirecting': a quiet placeholder while we check the session
  // or hand over to the login page.
  return (
    <div className="h-screen flex items-center justify-center bg-slate-50 font-body">
      <p className="text-xs font-bold text-slate-400">Signing in…</p>
    </div>
  );
}
